import { TagType } from 'phoenix/domain/tags';
import {
	TagService,
	TrackingService
} from 'sharebase/services';

/**
* @ngdoc service
* @name  sharebase-app.sbaTagDataStore
* 
* @description 
* A datastore used to interact with tags.
* 
**/
export function TagDataStoreFactory(
	$q:ng.IQService, 
	sbTagService:TagService,
	sbTrackingService:TrackingService
) {
	let documentId = null;
	let tagTypes = null;
	let userTagType:TagType = null;
	let userTags = null;
	let documentTags = null;
	let docTagsPromise;

	return {
		/**
		* @ngdoc method
		* @name sbaTagDataStore#loadTagTypes
		* @methodOf sharebase-app.sbaTagDataStore
		* @kind function
		*
		* @description
		* Loads a user's tag types
		*
		* @returns {Deferred} A promise that will resolve with the user's tag types
		*/
		loadTagTypes,

		/**
		* @ngdoc method
		* @name sbaTagDataStore#loadMyTags
		* @methodOf sharebase-app.sbaTagDataStore
		* @kind function
		*
		* @description
		* Loads a user's my tags
		*
		* @returns {Deferred} A promise that will resolve with the user's my tags
		*/
		loadMyTags,

		/**
		* @ngdoc method
		* @name sbaTagDataStore#loadDocumentTags
		* @methodOf sharebase-app.sbaTagDataStore
		* @kind function
		*
		* @description
		* Loads a document's tags
		* 
		* @param {object} documentId A Document ID
		*
		* @returns {Deferred} A promise that will resolve with a selected document's tags
		*/
		loadDocumentTags,

		/**
		* @ngdoc property
		* @name sbaTagDataStore#userTags
		* @propertyOf sharebase-app.sbaTagDataStore
		* @kind property
		*
		* @description
		* A user's array of tags
		* 
		* @returns {array} An array of a selected user's tags
		*/
		get userTags() { return userTags; },

		/**
		* @ngdoc property
		* @name sbaTagDataStore#documentTags
		* @propertyOf sharebase-app.sbaTagDataStore
		* @kind property
		*
		* @description
		* A given document's tags
		* 
		* @param {object} documentId A Document ID
		*
		* @returns {array} An array of a selected document's tags
		*/
		get documentTags() { return documentTags; },

		/**
		* @ngdoc method
		* @name sbaTagDataStore#setTags
		* @propertyOf sharebase-app.sbaTagDataStore
		* @kind property
		*
		* @description
		* sets an current array of tags to the document
		*/
		setDocumentTags,

		/**
		* @ngdoc method
		* @name sbaTagDataStore#removeTag
		* @propertyOf sharebase-app.sbaTagDataStore
		* @kind property
		*
		* @description
		* removes a tag from a document
		*/
		removeDocumentTag,
		clearStore
	};

	function loadTagTypes() {
		return sbTagService.getTagTypes()
			.then(function (tagTypes) {
				tagTypes = tagTypes;

				for (let i = 0; i < tagTypes.length; i++) {
					let tagType = tagTypes[i];
					if (tagType.TagTypeName === 'My Tags') {
						userTagType = tagType;
						break;
					}
				}

				return tagTypes;
			});
	}

	function loadMyTags() {
		return loadTagTypes()
			.then(function () {
				if (!userTagType) { return; }
				return sbTagService.getTags(userTagType);
			}).then(function (tags) {
				userTags = tags;
				return userTags;
			});
	}

	function loadDocumentTags(id) {
		if(docTagsPromise){
			return docTagsPromise;
		}
		
		documentId = id;
		return docTagsPromise = sbTagService.getDocumentTags(documentId)
			.then(function (tags) {
				// remove dupes
				tags.AnonymousTags = tags.AnonymousTags.filter(function(item, i, arr){
					return arr.indexOf(item) === i;
				});
				documentTags = tags;
				documentId = documentId;

				return documentTags;
			});
	}

	function setDocumentTags() {
		if (!documentId) { return; }

		sbTrackingService.trackClick('Tag Added', 'Document details panel');
		return sbTagService.setDocumentTags(documentTags);
	}

	function removeDocumentTag(id, tag) {
		if (!id) { return; }
		
		sbTrackingService.trackClick('Tag Removed', 'Document details panel');
		return sbTagService.removeDocumentTag(id, tag);
	}

	function clearStore() {
		docTagsPromise = userTags = userTagType = documentId = documentTags = tagTypes = null;
	}
}

TagDataStoreFactory.$inject =  [
	'$q',
	'sbTagService',
	'sbTrackingService'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/tagDataStore.ts